import { Game } from "../interfaces/game.interface";
import { GameHistoryWithGame } from "../interfaces/gameHistory.interface";
import { User } from "../interfaces/user.interface";
import axios from "axios";

class UserService {
  baseUrl: string;
  constructor() {
    this.baseUrl = process.env.REACT_APP_BACKEND || "";
  }
  // v1
  getUserBasicInfo(userId: string) {
    return new Promise<User>((resolve, reject) => {
      axios({
        method: "GET",
        url: `${this.baseUrl}/game_users/api/game-user?userId=${userId}`,
      })
        .then((res: { data: { success: boolean; data: User } }) => {
          if (res.data.success) {
            resolve(res.data.data);
          } else {
            reject(res.data.data);
          }
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }
  updateUserAvatar(userId: string, avatar: string) {
    return new Promise<boolean>((resolve, reject) => {
      axios({
        method: "POST",
        url: `${this.baseUrl}/game_users/api/game-user-update-avatar`,
        data: JSON.stringify({
          userId,
          avatar,
        }),
      })
        .then((res: { data: { success: boolean; data: string } }) => {
          if (res.data.success) {
            resolve(res.data.success);
          } else {
            reject(res.data.success);
          }
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }
  playGame(userId: string, gameId: string) {
    return new Promise<boolean>((resolve, reject) => {
      axios({
        method: "POST",
        url: `${this.baseUrl}/game_history/api/game-history/v2`,
        data: {
          userId,
          gameId,
        },
      })
        .then((res: { data: { success: boolean } }) => {
          resolve(res.data.success);
        })
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }
  gameHistory(userId: string) {
    return new Promise<GameHistoryWithGame[]>((resolve, reject) => {
      axios({
        method: "GET",
        url: `${this.baseUrl}/game_history/api/game-history/v2?userId=${userId}`,
      })
        .then(
          (res: {
            data: { success: boolean; data: GameHistoryWithGame[] };
          }) => {
            if (res.data.success) {
              resolve(res.data.data);
            } else {
              reject(res.data.data);
            }
          }
        )
        .catch((err: any) => {
          reject(err.message);
        });
    });
  }
  loadHighscore(userId: string) {
    return new Promise<Array<{ game: Game; score: number }>>(
      (resolve, reject) => {
        axios({
          method: "GET",
          url: `${this.baseUrl}/game_leaderboard/api/get-user-highscores?userId=${userId}`,
        })
          .then(
            (res: {
              data: {
                success: boolean;
                data: Array<{ game: Game; score: number }>;
              };
            }) => {
              resolve(res.data.data);
            }
          )
          .catch((err: any) => {
            if (err.message.indexOf("404") > -1) {
              resolve([]);
            } else {
              reject(err.message);
            }
          });
      }
    );
  }
  // v2
}

export const userService = new UserService();
